// imports
import { createBrowserHistory } from 'history';

// local imports

export const history = createBrowserHistory();
